import {isEmpty, str_replace} from "./helpers";

export function roundNumber(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

export const shortMoneyNumber = (number, decimalPoint = '٫', round = false) => {
    number = toEnglishNumber(String(number));

    if (isNaN(Number(number))) {
        return {num: 0, unit: "", real: 0};
    }

    let tempNumber = 0;
    let result = 0;

    if (number >= 1000000000) {
        if (number % 100000000 && !isEmpty(number.charAt(1)) && number.charAt(1) === '0') {
            let num = number;

            if (round) {
                num = roundNumber(num, 2);
            }

            return {num: decimalPrice(num, ','), unit: "", real: number};
        }

        tempNumber = number / 1000000000;
        if (round) {
            tempNumber = roundNumber(tempNumber, 2);
        }

        result = (tempNumber === parseInt(tempNumber)) ? String(tempNumber) : String(parseFloat(tempNumber).toFixed(3));
        result = result.replace('.', decimalPoint);

        return {num: result, unit: "میلیارد", real: number};
    } else if (number >= 1000000) {
        /*if (number % 100000 && !isEmpty(number.charAt(1)) && number.charAt(1) === '0') {
            let num = number;

            if (round) {
                num = roundNumber(num, 2);
                console.log(num,decimalPrice(num, ','))
            }

            return {num: decimalPrice(num, ','), unit: "", real: number};
        }*/

        tempNumber = number / 1000000;
        if (round) {
            tempNumber = roundNumber(tempNumber, 2);
        }

        result = (tempNumber === parseInt(tempNumber)) ? String(tempNumber) : String(parseFloat(tempNumber).toFixed(3));
        result = result.replace('.', decimalPoint);

        return {num: result, unit: "میلیون", real: number};
    } else if (number >= 1000) {
        tempNumber = number / 1000;

        if (round) {
            tempNumber = roundNumber(tempNumber, 2);
        }

        result = (tempNumber === parseInt(tempNumber)) ? String(tempNumber) : String(parseFloat(tempNumber).toFixed(3));
        result = result.replace('.', decimalPoint);

        return {num: result, unit: "هزار", real: number};
    }

    return {num: number, unit: "", real: number};
};

function decimalPrice(price, decimalPoint) {
    let decimalPrice = price;

    for (let i = (price.length - 3); i > 0; i -= 3) {
        decimalPrice = decimalPrice.substr(0, i) + decimalPoint + decimalPrice.substr(i, decimalPrice.length);
    }

    return decimalPrice;
}

export function formatDecimalPrice(price, decimalPoint) {
    let decimalPrice = String(price);

    for (let i = (decimalPrice.length - 3); i > 0; i -= 3) {
        decimalPrice = decimalPrice.substr(0, i) + decimalPoint + decimalPrice.substr(i, decimalPrice.length);
    }

    return decimalPrice;
}

export const shortAreaNumber = (number) => {
    if (isNaN(Number(number))) {
        return {num: 0, unit: "", real: 0};
    }
    let tempNumber = 0;
    let result = 0;

    if (number >= 10000) {
        tempNumber = number / 10000;
        result = tempNumber;
        return {num: result, unit: "هکتار", real: number};
    } else if (number >= 1000) {
        tempNumber = number / 1000;
        result = tempNumber;
        return {num: result, unit: "هزار متر", real: number};
    }

    return {num: number, unit: "متر", real: number};
};

export const shortAgeNumber = (number) => {
    if (isNaN(Number(number))) {
        return {num: 0, unit: "", real: 0};
    }

    let tempNumber = 0;
    let result = 0;

    if (Number(number) === 0) {
        return {num: "نوساز", unit: "", real: number};
    }

    return {num: number, unit: "سال", real: number};
};

export function GetAgeUnit($input) {
    if ($input === -1) {
        return {num: '', unit: '-'};
    } else if ($input === 0) {
        return {num: 'نوساز', unit: ''};
    } else if ($input >= 1 && $input <= 30) {
        return {num: $input, unit: 'سال ساخت'};
    } else if ($input === 31) {
        return {num: 'بازسازی', unit: ''};
    } else if ($input === 32) {
        return {num: 'قدیمی', unit: ''};
    }

    return {num: '', unit: ''};
}

export const handleFormatNumbers = (number) => {
    let value = toEnglishNumber(number);
    value = Number(value.replace(/[,]*/g, ''));
    value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (value !== 'NaN') {
        return value;
    }
    return null;
};

export const toEnglishNumber = (text) => {
    const persianChars = ['۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰'];
    const englishChars = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    let index = 0;
    let englishText = '';

    if (text) {
        for (var i = 0; i < text.length; i++) {
            index = persianChars.indexOf(text[i]);
            if (index >= 0) {
                englishText += englishChars[index];
            } else {
                englishText += text[i];
            }
        }
    }
    return englishText;
};

export function formatPhoneNumber(str, type = 'mobile', hideMiddle = false) {
    const middle_count = (type === 'phone') ? 4 : 3;
    const last_count = 4;

    let cleaned = ('' + str).replace(/\D/g, '');

    const first = cleaned.substr(0, cleaned.length - (middle_count + last_count));
    const middle = cleaned.substr(cleaned.length - (middle_count + last_count), middle_count);
    const last = cleaned.substr(cleaned.length - last_count);

    if (isEmpty(first) || isEmpty(last) || isEmpty(middle)) {
        return str;
    }

    if (first && last && middle && !hideMiddle) {
        return last + ' ' + middle + ' ' + first;
    }

    if (first && last && middle && hideMiddle) {
        return first + 'xxx' + last
    }

    return null
}

export const formatToPhone = (input) => {

    input = input.replace(/\D/g, '').substring(0, 11); // First ten digits of input only
    const areaCode = input.substring(0, 4);
    const middle = input.substring(4, 7);
    const last = input.substring(7, 11);

    let format = '';

    if (input.length > 6) {
        format = areaCode + (!isEmpty(middle) ? ' ' + middle : '') + (!isEmpty(last) ? ' ' + last : '')
    } else if (input.length > 3) {
        format = areaCode + (!isEmpty(middle) ? ' ' + middle : '')
    } else if (input.length > 0) {
        format = areaCode
    }

    return format;
};

/**
 * @return {number}
 */
export function Round(num) {
    return Math.round(num);
}

export function number_to_text(input, appended = false) {
    const replaces = ['صفر', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه', 'ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده', 'بیست'];
    const appendedReplaces = ['صفرم', 'اول', 'دوم', 'سوم', 'چهارم', 'پنجم', 'ششم', 'هفتم', 'هشتم', 'نهم', 'دهم', 'یازدهم', 'دوازدهم', 'سیزدهم', 'چهاردهم', 'پانزدهم', 'شانزدهم', 'هفدهم', 'هجدهم', 'نوزدهم', 'بیستم'];
    const searches = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"];

    return str_replace(searches, (appended) ? appendedReplaces : replaces, input);
}
